import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { StepNavigatorService } from './services/step-navigator.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TokenLogin } from 'src/app/shared/models/login-response';

@Component({
  selector: 'app-step-navigator',
  templateUrl: './step-navigator.component.html',
  styleUrls: ['./step-navigator.component.scss']
})
export class StepNavigatorComponent implements OnInit {

  @Input()
  hideLeftButton = false;

  @Input()
  hideRightButton = false;

  @Input()
  disableNext = false;

  @Input()
  disablePrevious = false;

  @Input()
  disableOk = false;

  @Input()
  nextButtonType: string;

  @Input()
  okButtonType: string;

  @Input()
  previousLabel = 'Anterior';

  @Input()
  nextLabel = 'Próximo';

  @Input()
  flexPosition = 'right'

  @Output()
  whenPrevious = new EventEmitter<Event>();

  @Output()
  whenNext = new EventEmitter<Event>();

  @Output()
  whenOk = new EventEmitter<Event>();

  @Output()
  whenCancel = new EventEmitter<Event>();

  constructor(
    private stepNavService: StepNavigatorService
  ) { }

  ngOnInit() {
    this.nextButtonType = this.nextButtonType || 'button';
    this.okButtonType = this.okButtonType || 'button';
  }

  emitNext(event: Event): void {
    this.whenNext.emit(event);
  }

  emitPrevious(event: Event): void {
    this.whenPrevious.emit(event);
  }

  emitOk(event: Event): void {
    this.whenOk.emit(event);
  }

  emitCancel(event: Event): void {
    this.whenCancel.emit(event);
  }

  get isMultiMode(): Observable<boolean> {
    return this.stepNavService.mode().pipe(map(mode => mode == 'multi'));
  }

  get showLeftButton(): boolean {
    return !this.hideLeftButton;
  }

  get showRightButton(): boolean {
    return !this.hideRightButton;
  }
}
